import { Box, Button, Container, Grid, Typography } from "@mui/material"
import { useContext, useEffect, useState } from "react"

import { useApi } from "auth/useApi3"
import ClpTable from "components/ClpTable"
import { GlobalLoaderContext } from "components/GlobalLoadingProvider"
import { apiEndpoints } from "generated/apiEndpoints"

import { allRoutes } from "generated/routes"
import { NavLink } from "react-router-dom"

import moment from "moment"
import { StyledTableContainer } from "shared/styled/Global"
import { useTranslation } from "react-i18next"

const ListContract = () => {
  const { t } = useTranslation()
  const loadingContext = useContext(GlobalLoaderContext)

  const [contractResult, contractFuncs] = useApi()
  const [page, setPage] = useState(1)
  const [pageCount, setPageCount] = useState(0)
  const [pageSize, setPageSizeManual] = useState(25)
  const [sortState, setSortState] = useState({
    sortby: "regNumber",
    direction: "asc"
  })
  useEffect(() => {
    contractFuncs.get(
      apiEndpoints.vehicleregistryadmin.listpagedcontractrows
        .replace("{page}", page)
        .replace("{pagesize}", pageSize)
        .replace("{sortby}", sortState.sortby + " " + sortState.direction)
    )
  }, [contractFuncs, page, pageSize, sortState.direction, sortState.sortby])
  useEffect(() => {
    if (contractResult.status === 2) {
      setPageCount(contractResult.data.pageCount)
    }
  }, [contractResult])
  useEffect(() => {
    loadingContext.setLoading(() => contractResult.status === 1)
  })

  const columns = [
    {
      accessorKey: "regnr",
      header: t("global.table.regnr", "Reg No")
    },
    {
      accessorKey: "internNr",
      header: t("global.table.internal_number", "Internal no")
    },
    {
      accessorKey: "name",
      header: t("global.customer", "Customer")
    },
    {
      accessorKey: "assignmentNr",
      header: t("global.agreement_no", "Agreement no")
    },
    {
      accessorKey: "nrOfHours",
      header: t("global.hours", "Hours")
    },
    {
      accessorKey: "dateFrom",
      header: t("global.start_date", "Start date"),
      cell: ({ cell }) => {
        return moment(cell.row.original.dateFrom).format("YYYY-MM-DD HH:mm")
      }
    },
    {
      accessorKey: "dateTimeTo",
      header: t("global.end_date", "End date"),
      cell: ({ cell }) => {
        return moment(cell.row.original.dateTimeTo).format("YYYY-MM-DD HH:mm")
      }
    },
    {
      accessorKey: "subContract",
      header: t("global.subcontract", "Subcontract")
    }
  ]

  return (
    <div>
      <Container>
        <Box>
          <Grid container direction="row" justifyContent="space-between" alignItems="center">
            <Typography variant="h1">{t("global.agreement", "Agreement")}</Typography>

            <Button
              component={NavLink}
              to={allRoutes.ReportsVehiclereportsContractImport()}
              color="primary"
              variant="contained">
              {t("global.import_agreement", "Import agreement")}
            </Button>
          </Grid>
        </Box>
      </Container>
      <StyledTableContainer>
        <ClpTable
          columns={columns}
          pageCount={pageCount}
          pageSize={pageSize}
          currentpage={page}
          totalPage={pageCount}
          manualPagination={true}
          manualSortBy={true}
          setPage={setPage}
          setPageSizeManual={setPageSizeManual}
          manualPageSize={pageSize}
          hideSearch={true}
          hideFilter={true}
          manualSetSortState={setSortState}
          manualSortState={sortState}
          rows={contractResult.status === 2 && contractResult.data}
          loadingState={contractResult.status}
        />
      </StyledTableContainer>
    </div>
  )
}
export default ListContract
